exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-content {\n  padding-left: 35px;\n  padding-right: 35px; }\n\n.card-img-top {\n  max-height: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/brand-manage/brands.component.scss
// module id = ../../../../../src/app/views/brand-manage/brands.component.scss
// module chunks = main